import type { FaireProductEntity } from "../../entity_types/product";

export const p_yqzdgu42f2: FaireProductEntity = {
  token: "p_yqzdgu42f2",
  type: "product",
  name: "18\"Gold Filled 1.8mm Minimalist Link Layering Chain Necklace",
  brandToken: "b_374b66mxaz",
  brandName: "Aim Eternal",
  imageUrl: "https://cdn.faire.com/fastly/9a1e09ed5a73464e72c6a32230c1fb55127f1b968e7cc45833e6ebceec63e4e9.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0414f64d06643ee9b071df51cb9de8f8b2e7d4a74b7c0d3e8aad7a676104d3b9.jpeg",
    "https://cdn.faire.com/fastly/68709703a8f05cf9b53e50887de97248868040e54de9a5d3fe6943f3678a1caa.jpeg"
  ],
  priceDollars: 9.69,
  description: "\nItem Details:\n\nMaterial: Brass, 14K Gold Filled\n\nChain Style: Unique Chain \n\nLength: 17.7 Inches\n\nWidth: 1.8mm \n\nClosure: Spring Ring \n\n\n\nWant us to match the chains for a specific pendant from your order? Please leave a note at check out page so that we can take this request. Please follow this format on your message.\n\nChain Style desired: (preferably a link of one chain style as example from our website)\n\nPendants that you want us to match (SKU or the item link from our website):\n\nLength:\n\nWidth:\n\n",
  tags: [],
  msrpDollars: 29.06,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:59:02.164Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
